import { PreserveNumberAlias } from './alias.utils';

export type METERS = number & PreserveNumberAlias;

export const METERS_PER_MILE = 1609.34;
export const PRECISION = Math.pow(10, 5); // we just know the storage service returns this
// approx. from http://gis.stackexchange.com/a/2964
export const METERS_PER_DEGREE = 111111;
export const DEGREES_PER_RADIAN = 57.2957795;
